import React, { KeyboardEventHandler, useEffect, useRef } from "react"
import "./InputField.scss"

interface InputFieldType {
  placeholder?: string
  value?: string
  handleChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  calendar?: boolean
  file?: boolean
  errorMsg?: string
  filename?: string
  readOnly?: boolean
  title?: string
  className?: string
  type?: string
  max?: string
  accept?: string
  // onfocus?: (event: React.ChangeEvent<HTMLInputElement>) => void
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>
  handleBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void
  handleFocus?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function InputField({
  placeholder = "",
  value = "",
  handleChange,
  calendar,
  file = false,
  errorMsg,
  filename,
  readOnly = false,
  className,
  handleBlur,
  handleFocus,
  type,
  max,
  accept,
  // onfocus,
  onKeyDown = (event) => { },
}: InputFieldType) {
  const vitalsClasss =
    className === "red-text"
      ? "red-text"
      : className === "bold-text"
        ? "bold-text"
        : ""

  const inputRef = useRef<HTMLInputElement>(null)

  const handleClick = () => {
    if (calendar && inputRef.current) {
      inputRef.current.focus()
    }
  }

  const handleInputChange = (event: any) => {
    const inputValue = event?.target?.value;
    if (type === "number") {
      if (inputValue) {
        const parsedValue = parseInt(inputValue);
        if (!isNaN(parsedValue)) {
          handleChange && handleChange({ ...event, target: { ...event.target, value: parsedValue.toString() } });
        }
      } else {
        handleChange && handleChange(event)
      }
    } else {
      handleChange && handleChange(event);
    }
  };

  return (
    <div className={`custom-input ${className}`} onClick={handleClick}>
      {file === true ? (
        <div className="file-input-wrapper">
          <span className="upload-text">{filename ? filename : "Upload"} </span>
          <label htmlFor="file-upload" className={`custom-file-upload ${readOnly && "read-only"}`}>
            <div className="browse" aria-disabled={readOnly}>Browse</div>
          </label>
          <input
            id="file-upload"
            type="file"
            onChange={handleChange}
            value={value}
            accept={accept}
            readOnly={readOnly}
            disabled={readOnly}
          />
        </div>
      ) : (
        <input
          onKeyDown={onKeyDown}
          type={calendar ? "date" : type ? type : "text"}
          title={value}
          placeholder={placeholder}
          onChange={handleInputChange}
          value={value}
          readOnly={readOnly}
          onBlur={(e) => {
            e.preventDefault();
            handleBlur && handleBlur(e);
          }}
          onFocus={(e) => {
            e.preventDefault();
            handleFocus && handleFocus(e);
          }}
          className={`${readOnly ? "read-only" : ""} ${vitalsClasss}`}
          max={max && max}
          ref={inputRef}
        />
      )}

      {errorMsg && <div className="error">{errorMsg}</div>}
    </div>
  )
}

export default InputField
